import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { IconButton, InputAdornment, Tooltip } from '@mui/material';
import { SEARCH_ICON } from '../../constants/icons/SearchIcon';

import { COLOR_MAP } from '../../constants/ColorNames';
import styled from '@emotion/styled';
import React from 'react';
import { BootstrapTooltip } from '../../style/tooltips';
import { NOT_ALLOWED_ICON } from '../../constants/icons/NotAllowedIcon';
import { renderToStaticMarkup } from 'react-dom/server';

type GroupedProps = {
    showError?: boolean,
    errorMessage? : string,
    selectedValue: any,
    inputValue: string,
    campaignName: string,
    onInputChange: (event: any, newValue: any) => void,
    onValueSelect: (event: any, newValue: any) => void,
    renderOption: (props: object, option: any) => React.ReactNode,
    onCreateClick: () => void;
    options: any;
    disabled?: boolean;
    tooltip?: any;
}

const GroupHeader = styled('div')(({ theme }) => ({
    padding: '0.4rem 1rem',
    backgroundColor: COLOR_MAP.DISABLED
}));

const GroupItems = styled('ul')({
    padding: 0,
});

const svgToBase64 = (svgString: any) => {
    return 'data:image/svg+xml;base64,' + btoa(svgString);
}


const StyledAutoComplete = styled(Autocomplete)`
    .MuiAutocomplete-input{
        padding:0 !important
       
    }
    .MuiOutlinedInput-root {
       padding: 1.2rem!important;
    }
    .Mui-disabled {
        pointer-events: unset;
        cursor: url("data:image/svg+xml,${encodeURIComponent(renderToStaticMarkup(NOT_ALLOWED_ICON))}"), auto ;
        background-color: ${COLOR_MAP.GREY_9};
        .MuiOutlinedInput-notchedOutline {
            border-color: ${COLOR_MAP.GREY_9};
            }
        }
`
export default function Grouped(props: GroupedProps) {
  const [isCreateDisable, setIsCreateDisable] = React.useState(true)

    const { showError,
        errorMessage,
        selectedValue,
        campaignName,
        inputValue,
        onInputChange,
        onValueSelect,
        options,
        renderOption,
        onCreateClick,
        disabled,
        tooltip
      } = props

      const handleCreateClick = () => {
        setIsCreateDisable(true);
        onCreateClick();
    }
    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter' || event.key === 'Tab') {
            if(!isCreateDisable){
                handleCreateClick()
            }
        }
    };

    return (
        <BootstrapTooltip placement="bottom-start" title={disabled?<div style={{fontSize: '14px', fontFamily: 'Noto Sans', lineHeight: '22px', padding: '8px', maxWidth: '494px'}}>{tooltip || ''}</div>: ''}>
        <StyledAutoComplete
            disabled={disabled}
            popupIcon={<IconButton disabled={disabled}/>}
            freeSolo
            limitTags={3}
            id="grouped-demo"
            options={options}
            groupBy={(option: any) => option?.type}
            getOptionLabel={(option: any) => option.hasOwnProperty('title') ? option.title : option }
            filterOptions={(options, state) => {
              let updatedOptionsArray = options.filter((option : any) => option.title.toLowerCase().includes(inputValue?.toLowerCase())) 
              const matchingOptions = options.filter((option : any) => option.title.toLowerCase() === inputValue?.toLowerCase())
              if (matchingOptions.length > 0 || campaignName?.toLowerCase() === inputValue?.toLowerCase() || inputValue.length===0) {
                  setIsCreateDisable(true)
              }
              else {
                  setIsCreateDisable(false)
              }
              return updatedOptionsArray
          }}
            value={selectedValue}
            onChange={onValueSelect}
            inputValue={inputValue}
            onInputChange={onInputChange}
            sx={{
                '.MuiOutlinedInput-root': {
                    paddingLeft: '2rem !important'
                }
            }}
            renderGroup={(params) => {
              return (
                <>
                    <GroupHeader>{params.group}</GroupHeader>
                    <GroupItems>
                        {params.children}
                    </GroupItems>
                </>
              )
            }}
            renderOption={renderOption}
            renderInput={(params) => <TextField
                {...params}
                onKeyDown={handleKeyDown}
                error={showError}
                helperText={errorMessage}
                InputProps={{
                    ...params.InputProps,
                    startAdornment: <InputAdornment position="start">{SEARCH_ICON}</InputAdornment>,
                    endAdornment: <IconButton style={{ color: disabled || isCreateDisable ? COLOR_MAP.BORDER_GREY : COLOR_MAP.DARK_PURPLE,  fontFamily: 'Noto Sans', fontSize: '1.4rem'}} onClick={disabled || isCreateDisable ? undefined : handleCreateClick} disableRipple>New</IconButton>
                }}
                placeholder="Template" />
            }
        />
        </BootstrapTooltip>
    );
}
